export default "__VITE_ASSET__DShO0h94__"